export const AV_RENDER_COMPLETE = 'AV_Render_Complete';
export const DV_RENDER_COMPLETE = 'DV_Render_Complete';
export const AV_MOUNT_UPDATE_COMPLETE = 'AV_MountUpdate_Complete';
export const DV_SWIPE_STARTED = 'DayViewSwipeStarted';
export const DV_SWIPE_CANCELLED = 'DayViewSwipeCancelled';
export const DV_SWIPE_COMPLETED = 'DayViewSwipeCompleted';
export const ON_CALENDAR_SURFACE_DATE_CHANGE = 'On_Calendar_Surface_Date_Change';
export const SAVE_OR_SEND_BUTTON_CLICKED = 'SaveOrSendButtonClicked';
export const OPEN_COMPOSE_CLICKED = 'OpenComposeClicked';
export const NEW_WORKSPACE_BOOKING_CLICKED = 'NewWorkspaceBookingClicked';
export const QUICKCAPTURE_OVERLAY_CLICKED = 'CalendarEventQuickCaptureOverlayClicked';
export const CALENDAR_SELECTION_START = 'CalendarSelectionStart';
export const CALENDAR_SELECTION_END = 'CalendarSelectionEnd';
export const CALENDAR_UNSELECTED_AFTER_SELECTION = 'CalendarUnselectedAfterSelection';
export const LOCAL_SELECTION_DONE = 'LocalSelectionDone';
export const UNSELECT_DEFAULT_CAL = 'UnselectDefaultCalendar';
export const EVENT_ACTION_SELECT_SINGLE_OR_SERIES_ABORT = 'EventActionSelectSingleOrSeriesAbort';
export const BUILDING_SPOKE_CLICKED = 'BuildingSpokeClicked';
export const WORKSPACE_SPOKE_CLICKED = 'WorkspaceSpokeClicked';
export const BUILDING_ADDED = 'BuildingAdded';
export const WORKSPACE_ADDED = 'WorkspaceAdded';
export const LOCATION_ADDED = 'LocationAdded';
export const LOCATION_CANCEL_CLICKED = 'LocationCancelClicked';
export const BUILDING_SPOKE_CANCEL_CLICKED = 'BuildingSpokeCancelClicked';
export const WORKSPACE_SPOKE_CANCEL_CLICKED = 'WorkspaceSpokeCancelClicked';
export const START_AND_END_DATE_CHANGED = 'StartAndEndDateChanged';
export const DATE_AND_TIME_PICKER_OPENED = 'Date&TimePickerOpened';
export const DATE_TIME_PICKER_SWITCH_CLICKED = 'DateTimePickerSwitchClicked';
export const DATE_PICKER_CANCEL_CLICKED = 'DatePickerCancelClicked';
export const DATE_TIME_PICKER_OVERLAY_CLICKED = 'DateTimePickerOverlayClicked';
export const WORKFLOW_DATE_AND_TIME_CHANGED = 'WF_DateAndTimeChanged';
